/**
 * User Profile Service
 *
 * HTTP wrappers for the current user's self-service endpoints. These are
 * NOT routed through the RA dataProvider — this feature isn't a Resource,
 * so the generic list/create/edit machinery doesn't apply. Direct
 * `httpClient` calls keep the contract explicit and the endpoint names
 * matching Angular's `user-service.ts` exactly.
 */

import { httpClient } from '@/utils/httpClient';
import type { NotifyEnvelope } from '@/types/api';
import type {
  PasswordResetPayload,
  ProfileUpdatePayload,
  UserProfile,
} from '../types/userProfile';

export const getUserProfileById = async (id: string): Promise<UserProfile> => {
  const { data } = await httpClient.get<NotifyEnvelope<UserProfile>>(
    `/user/get-user-by-keycloakId/${encodeURIComponent(id)}`
  );
  return data.Response;
};

export const updateUserProfile = async (
  payload: ProfileUpdatePayload
): Promise<void> => {
  await httpClient.post<NotifyEnvelope<unknown> | undefined>(
    '/register-platform-user',
    payload
  );
};

export const updateUserPassword = async (
  payload: PasswordResetPayload
): Promise<void> => {
  await httpClient.put<NotifyEnvelope<unknown> | undefined>(
    '/user/update-password',
    payload
  );
};
